import ButtonComponent, {
  Props as ButtonProps,
} from '@shared/Form/Button/Button'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { IconImportFile, IconExportFile } from '@shared/icons'

interface IButton {
  Save: typeof Save
  Cancel: typeof Cancel
  Delete: typeof Delete
  Edit: typeof Edit
  Add: typeof Add
  GotoEdit: typeof GotoEdit
  Import: typeof Import
  ManualAdd: typeof ManualAdd
  Search: typeof Search
  Quit: typeof Quit
  Continue: typeof Continue
  Export: typeof Export
}

const Button: IButton = {
  Save,
  Cancel,
  Delete,
  Edit,
  Add,
  GotoEdit,
  Import,
  ManualAdd,
  Search,
  Quit,
  Continue,
  Export,
}

type Props = {
  className?: string
  label?: string
} & ButtonProps

function Save({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-save"
      type="primary"
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:save')}
    </ButtonComponent>
  )
}

function Cancel({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-cancel"
      type="primary"
      ghost
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:cancel')}
    </ButtonComponent>
  )
}

function Delete({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-delete"
      type="danger"
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:delete')}
    </ButtonComponent>
  )
}

function Edit({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-edit"
      type="primary"
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:edit')}
    </ButtonComponent>
  )
}

function Add({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-ok"
      type="primary"
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:add')}
    </ButtonComponent>
  )
}

function Search({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      type="primary"
      className={cx('w-96', className)}
      {...props}>
      {t('common:search')}
    </ButtonComponent>
  )
}

function GotoEdit(props: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent key="btn-goto" type="primary" size="small" {...props}>
      {t('device:go to edit')}
    </ButtonComponent>
  )
}

function Import(props: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      type="primary"
      shape="round"
      size="small"
      icon={<IconImportFile className="mr-4" />}
      {...props}>
      {props?.label || t('common:import')}
    </ButtonComponent>
  )
}

function Export(props: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      type="primary"
      shape="round"
      size="small"
      icon={<IconExportFile className="mr-4" />}
      {...props}>
      {t('common:export')}
    </ButtonComponent>
  )
}

function ManualAdd(props: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      type="primary"
      shape="round"
      size="small"
      icon="add"
      {...props}>
      {props?.label || t('common:manual add')}
    </ButtonComponent>
  )
}

function Quit({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-cancel"
      type="primary"
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:discard')}
    </ButtonComponent>
  )
}

function Continue({ className, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <ButtonComponent
      key="btn-cancel"
      type="primary"
      ghost
      size="small"
      className={cx('w-96', className)}
      {...props}>
      {t('common:continue editing')}
    </ButtonComponent>
  )
}

export default Button
